import React, { useEffect } from 'react';

import EmbeddedFrame from 'components/molecules/EmbeddedFrame/EmbeddedFrame';
import { DEMO_IFRAME_SCREEN_VIEW } from 'utils/mixpanelEventNames';
import { trackEventMixpanel } from 'utils/mixpanel';
import { IframeScreenConfig } from 'types/screenRoutes';

type IframeScreenPageProps = {
    entry: {
        label?: string;
        id?: string;
        path?: string;
        iframe?: IframeScreenConfig;
    };
};

// Route-level adapter: reads the config entry and the analytics concern, then hands the
// plain url/title over to EmbeddedFrame, which knows nothing about routing or config.
const IframeScreenPage = ({ entry }: IframeScreenPageProps) => {
    const { id, path, label, iframe } = entry;

    useEffect(() => {
        trackEventMixpanel(DEMO_IFRAME_SCREEN_VIEW, { screenId: id, path });
    }, [id, path]);

    if (!iframe?.url) return null;

    // Stretches into the flex column its container establishes instead of asking for a
    // percentage of an auto height. No chrome dimension is read here or in EmbeddedFrame.
    return (
        <div className="flex flex-col flex-1 min-h-0 w-full">
            <EmbeddedFrame url={iframe.url} title={label ?? ''} />
        </div>
    );
};

export default IframeScreenPage;
